/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './external-demand-source-item-page.component.html';

import {ADMIN_RESOURCE_PAGES} from '../../common/controller/admin-resource-pages';
import {SignalAdminResourcePageState} from '../../common/controller/signal-admin-resource-page-state';
import {ExternalDemandSourceModel} from './external-demand-source-api.service';
import {ExternalDemandSourceAnalysisPageComponent} from './external-demand-source-analysis-page.component';
import {ExternalDemandSourceEditPageComponent} from './external-demand-source-edit-page.component';

@Component({
  standalone: true,
  imports: [
    ...ADMIN_RESOURCE_PAGES,
    ExternalDemandSourceAnalysisPageComponent,
    ExternalDemandSourceEditPageComponent
  ],
  selector: 'adn-external-demand-source-item-page',
  template
})
export class ExternalDemandSourceItemPageComponent {
  @Input() state: SignalAdminResourcePageState<ExternalDemandSourceModel>;
}
